import { render, staticRenderFns } from "./pie_config.vue?vue&type=template&id=5c6c2421&"
import script from "./pie_config.vue?vue&type=script&lang=js&"
export * from "./pie_config.vue?vue&type=script&lang=js&"
import style0 from "./pie_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports